/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable jsx-a11y/anchor-is-valid */
export default function Contact() {
  return (
    <>
      <div className="rts-hosting-banner rts-hosting-banner-bg banner-default-height">
        <div className="container">
          <div className="row">
            <div className="banner-area">
              <div className="rts-hosting-banner rts-hosting-banner__content w-530 contact__banner">
                <span className="starting__price">Liên hệ</span>
                <h1 className="banner-title">Hãy liên hệ với chúng tôi</h1>
                <p className="slogan">
                  Thời gian là tiền bạc! Chúng tôi xem trọng khách hàng và thời
                  gian của mọi người, vì vậy, đội ngũ của chúng tôi luôn làm tốt
                  nhất có thể để giúp bạn giải quyết vấn đề nhanh chóng!
                </p>
                <div className="hosting-action">
                  <a
                    href="#"
                    className="btn__two secondary__bg secondary__color"
                  >
                    Liên hệ <i className="fa-regular fa-arrow-right" />
                  </a>
                </div>
              </div>
              <div className="rts-hosting-banner__image contact">
                <img
                  src="assets/images/banner/banner__contact__image.svg"
                  alt=""
                />
                <img
                  className="shape one"
                  src="assets/images/banner/banner__contact__image-sm1.svg"
                  alt=""
                />
                <img
                  className="shape two top-bottom2"
                  src="assets/images/banner/banner__contact__image-sm2.svg"
                  alt=""
                />
                <img
                  className="shape three"
                  src="assets/images/banner/banner__contact__image-sm3.svg"
                  alt=""
                />
                <img
                  className="shape four left-right2"
                  src="assets/images/banner/banner__contact__image-sm4.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="rts-contact-form no-bg pt--120">
        <div className="container">
          <div className="row g-30 pb--120 justify-content-sm-center">
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-10">
              <div className="single-contact-method">
                <div className="method">
                  <div className="icon">
                    <i className="fa-thin fa-map-location-dot" />
                  </div>
                  <div className="content w-220">
                    <h5 className="info mb-0">
                      Đừng ngần ngại liên hệ trực tiếp với chúng tôi khi có bất cứ vấn đề gì.
                    </h5>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-10">
              <div className="single-contact-method">
                <div className="method">
                  <div className="icon">
                    <i className="fa-thin fa-envelope-open" />
                  </div>
                  <div className="content w-220">
                    <h5 className="info mb-0">
                    <a href="https://t.me/server99net">
                      <span>
                        <i className="fa-brands fa-telegram" />
                      </span>
                      server99net
                    </a>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-10">
              <div className="single-contact-method">
                <div className="method">
                  <div className="icon">
                    <i className="fa-thin fa-phone" />
                  </div>
                  <div className="content w-220">
                    <h5 className="info mb-0">
                      <a href="callto:0859633956">0859633956</a> <br />
                    </h5>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-10">
              <div className="single-contact-method">
                <div className="method">
                  <div className="icon">
                    <svg
                      width={47}
                      height={39}
                      viewBox="0 0 47 39"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M32.6538 24.6879C32.4741 24.6888 32.2998 24.6257 32.1622 24.5101L26.44 19.8758C26.35 19.8013 26.2776 19.7077 26.2279 19.602C26.1782 19.4962 26.1524 19.3808 26.1523 19.2639V6.44918C26.1523 6.2411 26.235 6.04154 26.3821 5.89441C26.5293 5.74727 26.7288 5.66461 26.9369 5.66461C27.145 5.66461 27.3446 5.74727 27.4917 5.89441C27.6388 6.04154 27.7215 6.2411 27.7215 6.44918V18.8925L33.1507 23.2913C33.2799 23.3947 33.3731 23.5362 33.417 23.6956C33.4609 23.8551 33.4534 24.0243 33.3954 24.1792C33.3374 24.3341 33.2319 24.4667 33.094 24.558C32.9561 24.6494 32.7929 24.6948 32.6277 24.6879H32.6538Z"
                        fill="#2D3C58"
                      />
                      <path
                        d="M19.0586 27.8315H10.308C10.0999 27.8315 9.90037 27.7488 9.75323 27.6017C9.6061 27.4546 9.52344 27.255 9.52344 27.0469C9.52344 26.8389 9.6061 26.6393 9.75323 26.4922C9.90037 26.345 10.0999 26.2624 10.308 26.2624H19.0586C19.2667 26.2624 19.4663 26.345 19.6134 26.4922C19.7605 26.6393 19.8432 26.8389 19.8432 27.0469C19.8432 27.255 19.7605 27.4546 19.6134 27.6017C19.4663 27.7488 19.2667 27.8315 19.0586 27.8315Z"
                        fill="#2D3C58"
                      />
                      <path
                        d="M15.5084 19.4104H0.784573C0.576491 19.4104 0.376932 19.3278 0.229796 19.1806C0.0826602 19.0335 0 18.8339 0 18.6259C0 18.4178 0.0826602 18.2182 0.229796 18.0711C0.376932 17.9239 0.576491 17.8413 0.784573 17.8413H15.5084C15.7165 17.8413 15.916 17.9239 16.0632 18.0711C16.2103 18.2182 16.293 18.4178 16.293 18.6259C16.293 18.8339 16.2103 19.0335 16.0632 19.1806C15.916 19.3278 15.7165 19.4104 15.5084 19.4104Z"
                        fill="#2D3C58"
                      />
                      <path
                        d="M9.90568 10.8952H4.6752C4.46712 10.8952 4.26756 10.8125 4.12042 10.6654C3.97329 10.5183 3.89063 10.3187 3.89062 10.1106C3.89062 9.90254 3.97329 9.70298 4.12042 9.55585C4.26756 9.40871 4.46712 9.32605 4.6752 9.32605H9.90568C10.1138 9.32605 10.3133 9.40871 10.4605 9.55585C10.6076 9.70298 10.6903 9.90254 10.6903 10.1106C10.6903 10.3187 10.6076 10.5183 10.4605 10.6654C10.3133 10.8125 10.1138 10.8952 9.90568 10.8952Z"
                        fill="#2D3C58"
                      />
                      <path
                        d="M26.9369 34.1707C26.7288 34.1707 26.5293 34.088 26.3821 33.9409C26.235 33.7938 26.1523 33.5942 26.1523 33.3861V33.2292C26.1523 33.0211 26.235 32.8216 26.3821 32.6744C26.5293 32.5273 26.7288 32.4446 26.9369 32.4446C27.145 32.4446 27.3446 32.5273 27.4917 32.6744C27.6388 32.8216 27.7215 33.0211 27.7215 33.2292V33.3861C27.7215 33.5942 27.6388 33.7938 27.4917 33.9409C27.3446 34.088 27.145 34.1707 26.9369 34.1707Z"
                        fill="#2D3C58"
                      />
                      <path
                        d="M41.5548 20.0483H41.3979C41.1898 20.0483 40.9902 19.9656 40.8431 19.8185C40.6959 19.6714 40.6133 19.4718 40.6133 19.2637C40.6133 19.0556 40.6959 18.8561 40.8431 18.709C40.9902 18.5618 41.1898 18.4792 41.3979 18.4792H41.5548C41.7629 18.4792 41.9624 18.5618 42.1095 18.709C42.2567 18.8561 42.3393 19.0556 42.3393 19.2637C42.3393 19.4718 42.2567 19.6714 42.1095 19.8185C41.9624 19.9656 41.7629 20.0483 41.5548 20.0483Z"
                        fill="#2D3C58"
                      />
                      <path
                        d="M8.64242 22.5903C8.45353 22.5908 8.27091 22.5226 8.12852 22.3985C7.98613 22.2744 7.89366 22.1028 7.8683 21.9156C7.74767 21.0369 7.68998 20.1507 7.6957 19.2637C7.6957 19.0556 7.77836 18.8561 7.9255 18.709C8.07263 18.5618 8.27219 18.4792 8.48027 18.4792C8.68835 18.4792 8.88791 18.5618 9.03505 18.709C9.18218 18.8561 9.26484 19.0556 9.26484 19.2637C9.26493 20.0773 9.32086 20.89 9.43222 21.6959C9.4461 21.7995 9.43916 21.9047 9.41181 22.0056C9.38445 22.1064 9.33723 22.2008 9.27292 22.2831C9.20861 22.3654 9.1285 22.4341 9.0373 22.4851C8.94609 22.536 8.84563 22.5682 8.7418 22.5799L8.64242 22.5903Z"
                        fill="#2D3C58"
                      />
                      <path
                        d="M26.9368 38.5173C24.3491 38.5264 21.7866 38.0095 19.4048 36.998C17.023 35.9865 14.8716 34.5014 13.0812 32.633C12.9619 32.4795 12.9037 32.2872 12.9181 32.0933C12.9325 31.8994 13.0183 31.7177 13.1591 31.5835C13.2998 31.4493 13.4853 31.3722 13.6797 31.367C13.874 31.3618 14.0634 31.429 14.211 31.5555C15.8556 33.2705 17.8318 34.6329 20.0196 35.56C22.2073 36.4871 24.5608 36.9594 26.9368 36.9482C30.0888 36.9473 33.1832 36.104 35.8998 34.5056C38.6164 32.9071 40.8564 30.6117 42.388 27.8569C43.9196 25.102 44.687 21.9879 44.6109 18.8369C44.5348 15.6858 43.6179 12.6124 41.9551 9.93471C40.2923 7.25703 37.9441 5.07242 35.1535 3.60703C32.3629 2.14163 29.2314 1.44871 26.083 1.59999C22.9347 1.75127 19.884 2.74126 17.2468 4.46747C14.6095 6.19368 12.4816 8.59338 11.0832 11.4182C10.9903 11.6047 10.827 11.7468 10.6294 11.813C10.4317 11.8792 10.2158 11.8642 10.0293 11.7712C9.84268 11.6783 9.70066 11.515 9.63445 11.3174C9.56824 11.1197 9.58326 10.9038 9.6762 10.7173C11.1987 7.64042 13.5161 5.02648 16.3882 3.14607C19.2603 1.26567 22.5829 0.187174 26.0119 0.022243C29.4409 -0.142688 32.8516 0.611944 35.891 2.20801C38.9303 3.80407 41.4878 6.18354 43.2986 9.10006C45.1095 12.0166 46.1078 15.3641 46.1902 18.7961C46.2727 22.228 45.4363 25.6196 43.7676 28.6198C42.099 31.6199 39.6587 34.1194 36.6995 35.8596C33.7403 37.5998 30.3698 38.5174 26.9368 38.5173Z"
                        fill="#2D3C58"
                      />
                      <path
                        d="M5.88828 27.8315H4.46035C4.25227 27.8315 4.05271 27.7488 3.90558 27.6017C3.75844 27.4546 3.67578 27.255 3.67578 27.0469C3.67578 26.8389 3.75844 26.6393 3.90558 26.4922C4.05271 26.345 4.25227 26.2624 4.46035 26.2624H5.88828C6.09636 26.2624 6.29592 26.345 6.44305 26.4922C6.59019 26.6393 6.67285 26.8389 6.67285 27.0469C6.67285 27.255 6.59019 27.4546 6.44305 27.6017C6.29592 27.7488 6.09636 27.8315 5.88828 27.8315Z"
                        fill="#2D3C58"
                      />
                      <path
                        d="M9.35872 14.1277C9.22661 14.1262 9.097 14.0915 8.98175 14.0269C8.86651 13.9624 8.76931 13.8699 8.69905 13.758C8.6288 13.6461 8.58773 13.5184 8.57962 13.3865C8.5715 13.2546 8.59659 13.1228 8.6526 13.0032L9.74054 10.7279C9.78484 10.6349 9.84705 10.5514 9.92359 10.4824C10.0001 10.4134 10.0895 10.3601 10.1867 10.3256C10.2838 10.2911 10.3868 10.2761 10.4897 10.2814C10.5927 10.2867 10.6936 10.3123 10.7866 10.3566C10.8797 10.4009 10.9631 10.4631 11.0322 10.5396C11.1012 10.6162 11.1545 10.7056 11.189 10.8027C11.2235 10.8998 11.2385 11.0028 11.2332 11.1058C11.2278 11.2087 11.2023 11.3096 11.158 11.4027L10.0701 13.6832C10.0052 13.8166 9.9041 13.9291 9.77829 14.0077C9.65248 14.0863 9.50707 14.1279 9.35872 14.1277Z"
                        fill="#2D3C58"
                      />
                    </svg>
                  </div>
                  <div className="content w-220">
                    <h5 className="info mb-0">
                      Mon-Fri: 9 AM – 10 PM Saturday: 9 AM – 6 PM
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="rts-contact-map-area">
        <div className="section-inner">
          <div className="contact-map-area-fluid">
            <iframe
              className="contact-map"
              src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d14602.288851207937!2d90.47855065!3d23.798243149999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sbd!4v1663151706353!5m2!1sen!2sbd"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </section>
    </>
  );
}
